module.exports = __webpack_public_path__ + "img/jordbruk_med_paavirkningsgrad.a2ed346f.jpg";